import Marquee from "react-fast-marquee";

const ITEMS = [
  "Experienced leadership",
  "Proven results",
  "Accountability for taxpayers",
];

// Slow editorial ribbon separating major sections.
export const EditorialMarquee = () => (
  <section className="bg-[hsl(var(--navy))] py-8 md:py-10 overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={38} gradient={false} autoFill>
      {ITEMS.map((item, i) => (
        <span key={i} className="flex items-center">
          <span className="font-display italic text-2xl md:text-4xl text-[hsl(var(--cream))] px-6 md:px-10">
            {item}
          </span>
          <span className="text-[hsl(var(--campaign-red))] text-2xl md:text-4xl">&#9733;</span>
        </span>
      ))}
    </Marquee>
  </section>
);
